import React from "react";
import { Box, Typography, Button } from "@mui/material";
import constant from '../../constants/Constatnt';

const currentUrl = typeof window !== "undefined" ? window.location.origin : "http://localhost:3000";

const BlogSection = () => (
  <Box
    sx={{
      mt: { xs: 4, md: 6 },
      mb: { xs: 6, md: 10 },
      border: "1px solid",
      borderColor: "grey.900",
      borderRadius: 3,
      p: { xs: 2, sm: 3, md: 4 },
      width: "100%",
      maxWidth: { xs: "100%", md: "900px" },
      mx: "auto",
      bgcolor: "grey.900",
      boxShadow: 3,
    }}
  >
    <Typography
      component="h1"
      variant="h5"
      gutterBottom
      sx={{
        fontWeight: 700,
        color: "#ebe125ff",
        textAlign: { xs: "center", md: "left" },
        mb: 2,
      }}
    >
      {constant.websiteName} - The Premier Online Betting and Casino Platform in India
    </Typography>

    {/* Scrollable Inner Box */}
    <Box
      sx={{
        maxHeight: { xs: 400, md: 350 },
        overflowY: "auto",
        pr: { xs: 0, md: 2 },
        scrollbarWidth: "thin",
        "&::-webkit-scrollbar": {
          width: "8px",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "grey.800",
          borderRadius: "8px",
        },
      }}
    >
      {/* Blog Articles */}
      {[
        // ...articles array unchanged...
        {
          title: "Online Betting Sites in India: Reviews & Rankings",
          content: `Stay updated with expert reviews and rankings of the best online betting sites in India. Find trusted platforms with reliable payment options, fast withdrawals, and top bonuses at ${constant.websiteName}.`,
        },
        {
          title: "Is Online Betting Legal in India? Latest 2025 Updates",
          content: `Get the latest on the legal status of online betting in India with ${constant.websiteName}. Stay informed about laws, regulations, and what this means for bettors state-wise.`,
        },
        {
          title: "Best Fantasy Sports Platforms in India",
          content: `Discover the best fantasy sports sites including cricket, football, and kabaddi at ${constant.websiteName}. Compare features, bonuses, and user experience for fantasy sports lovers.`,
        },
        {
          title: "IPL Betting: Top Sites for Indian Premier League",
          content: `Explore top IPL betting sites with exclusive bonuses and live odds for Indian Premier League matches, recommended by ${constant.websiteName}. Bet confidently with our trusted picks.`,
        },
        {
          title: "UPI and Paytm Betting Sites: Fast Deposit & Withdrawal",
          content: `Find the best betting platforms supporting UPI, Paytm, and other popular Indian payment methods at ${constant.websiteName}. Enjoy secure and instant deposits and withdrawals.`,
        },
        {
          title: "Live Casino India: Best Games, Real Dealers, Reviews",
          content: `Engage with top live casino sites featuring roulette, blackjack, and baccarat. Detailed reviews and tips available at ${constant.websiteName} for an immersive experience.`,
        },
        {
          title: "Top Football Betting Sites for Indian Punters",
          content: `Compare the best football betting sites for Indian users with current odds, match previews, and bonuses at ${constant.websiteName}. Bet on EPL, ISL, and more with ease.`,
        },
        {
          title: "Cricket World Cup Betting: Odds, Tips & Best Sites",
          content: `Get expert tips, compare Cricket World Cup betting sites, and find promo codes for bonuses during ICC events at ${constant.websiteName}. Maximize your winnings with our guides.`,
        },
        {
          title: "Betting Apps Without KYC: What You Need to Know",
          content: `Discover safe and reliable betting apps in India that offer quick sign-up without KYC, curated by ${constant.websiteName}. Start betting faster and more discreetly.`,
        },
        {
          title: "Best Online Poker Sites in India: How to Play & Win",
          content: `Learn to pick the best poker sites in India with strategies and bonus guides from ${constant.websiteName}. Master Texas Hold’em and Omaha for real winnings.`,
        },
        {
          title: "Legal and Safe Betting Platforms in India",
          content: `Explore legal and safe betting platforms in India with ${constant.websiteName}. We ensure all recommended sites comply with regulations, providing a secure betting environment.`,
        },
        {
          title: "Best Online Sports Betting Sites in India",
          content: `Discover the top online sports betting sites in India with ${constant.websiteName}. Comprehensive reviews, tips, and strategies to enhance your betting experience.`,
        },
        {
          title: "Best Online Betting Apps in India",
          content: `Looking for the best online betting apps in India? ${constant.websiteName} offers a curated list of user-friendly and secure betting apps for betting on the go.`,
        },
        {
          title: "How to Get Started with Sports Betting",
          content: `Sports betting is an exciting way to engage with your favorite games. Understand basics, set budgets, explore bet types. Bet responsibly with guidance from ${constant.websiteName}.`,
        },
        {
          title: "Casino Games: Tips for Beginners",
          content: `New to casino games? Start with slots or roulette. Learn rules, play free versions, and try complex games gradually. Play for fun with tips from ${constant.websiteName}.`,
        },
        {
          title: "Responsible Gaming Practices",
          content: `Responsible gaming is key to enjoying betting and casino experiences. Set limits, take breaks, never chase losses. ${constant.websiteName} promotes safe gaming for all players.`,
        },
        {
          title: "Top Cricket Betting Sites in India",
          content: `Cricket is India's most popular betting sport. ${constant.websiteName} reviews top cricket betting sites highlighting live betting, competitive odds, and exclusive bonuses.`,
        },
        {
          title: "Secure Payment Methods for Indian Bettors",
          content: `Discover the safest payment options for online betting in India. ${constant.websiteName} recommends platforms supporting UPI, NetBanking, Paytm, and trusted fast transactions.`,
        },
        {
          title: "Live Betting: Experience Real-Time Thrills",
          content: `Live betting lets you place wagers as the action unfolds. ${constant.websiteName} guides through best live betting sites on cricket, football, and more to maximize winnings.`,
        },
        {
          title: "Casino Bonuses and Promotions in India",
          content: `Maximize your casino experience with exclusive bonuses and promotions. ${constant.websiteName} lists top offers including welcome bonuses, free spins, and cashback deals.`,
        },
        {
          title: "Mobile Betting: Bet Anytime, Anywhere",
          content: `Mobile betting apps make it easy to bet on sports and casino games from smartphones. ${constant.websiteName} reviews the best mobile-friendly platforms for seamless betting.`,
        },
        {
          title: "Understanding Betting Odds in India",
          content: `Learn how betting odds work and how to read them. ${constant.websiteName} explains decimal, fractional, and American odds formats for smarter betting decisions.`,
        },
        {
          title: `${constant.websiteName} Login`,
          content: `Access your account securely by logging in to ${constant.websiteName}. Use our safe and easy login portal for sports betting, casino games, and live betting. Quick sign-in and password recovery available.`,
          ctaText: "Login",
          ctaLink: `${currentUrl}/login`,
        },
        {
          title: `${constant.websiteName} Signup`,
          content: `New to ${constant.websiteName}? Create your account quickly and easily. Enjoy exclusive bonuses, instant deposits, and secure account registration to start betting immediately.`,
          ctaText: "Sign Up",
          ctaLink: `${currentUrl}/signup`,
        },
        {
          title: `Official ${constant.websiteName} Website`,
          content: `Visit the official ${constant.websiteName} website for the latest offers, promotions, and secure betting experience. Your trusted destination for online sports and casino betting.`,
          ctaText: "Visit Official Website",
          ctaLink: currentUrl,
        },
      ].map((article, idx) => (
        <BlogArticle key={idx} article={article} />
      ))}
    </Box>
  </Box>
);

// Update BlogArticle to show CTA if present
function BlogArticle({ article }) {
  const [expanded, setExpanded] = React.useState(false);

  return (
    <Box
      sx={{
        mb: 3,
        p: 2.5,
        bgcolor: "linear-gradient(135deg, #1e293b 60%, #0ea5e9 100%)",
        borderRadius: 3,
        border: "1px solid",
        borderColor: "primary.light",
        position: "relative",
        perspective: 1000,
        boxShadow: "0 8px 32px 0 rgba(14,165,233,0.35), 0 1.5px 0 #fff inset",
        transition: "transform 0.3s cubic-bezier(.25,.8,.25,1), box-shadow 0.2s, background 0.2s",
        "&:hover": {
          transform: "scale(1.03) rotateY(6deg) rotateX(2deg)",
          boxShadow: "0 16px 48px 0 rgba(14,165,233,0.45), 0 2px 0 #fff inset",
          bgcolor: "linear-gradient(135deg, #0ea5e9 60%, #1e293b 100%)",
        },
      }}
    >
      <Typography
        variant="h6"
        component="h2"
        gutterBottom
        sx={{
          fontWeight: 700,
          color: "#f59e42",
          letterSpacing: 0.5,
          textShadow: "0 2px 8px rgba(14,165,233,0.15)",
          mb: 1,
        }}
      >
        {article.title}
      </Typography>
      <Typography
        variant="body1"
        component="h3"
        paragraph
        sx={{
          color: "#e0f2fe",
          fontSize: "1.05rem",
          display: "-webkit-box",
          WebkitLineClamp: expanded ? "none" : 2,
          WebkitBoxOrient: "vertical",
          overflow: expanded ? "visible" : "hidden",
          textOverflow: expanded ? "unset" : "ellipsis",
          whiteSpace: expanded ? "normal" : "initial",
          mb: 2,
        }}
      >
        {article.content}
      </Typography>
      {/* CTA Button if present */}
      {article.ctaText && article.ctaLink && (
        <Box sx={{ mb: 1 }}>
          <Button
            variant="contained"
            color="primary"
            href={article.ctaLink}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              fontWeight: 700,
              borderRadius: 2,
              textTransform: "none",
              px: 2,
              py: 0.5,
              background: "linear-gradient(90deg, #f59e42 0%, #f43f5e 100%)",
              color: "#fff",
              boxShadow: "0 2px 8px 0 rgba(244,63,94,0.15)",
              mb: 1,
              "&:hover": {
                background: "linear-gradient(90deg, #f43f5e 0%, #f59e42 100%)",
              },
            }}
          >
            {article.ctaText}
          </Button>
        </Box>
      )}
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          size="small"
          onClick={() => setExpanded(!expanded)}
          sx={{
            mt: -1,
            px: 0.7,
            py: 0.1,
            minHeight: "18px",
            minWidth: "44px",
            fontSize: "0.65rem",
            borderRadius: 2,
            background: expanded
              ? "linear-gradient(90deg, #f59e42 0%, #f43f5e 100%)"
              : "linear-gradient(90deg, #38bdf8 0%, #0ea5e9 100%)",
            color: "#fff",
            fontWeight: 600,
            boxShadow: "0 2px 8px 0 rgba(56,189,248,0.15)",
            textTransform: "none",
            "&:hover": {
              background: expanded
                ? "linear-gradient(90deg, #f43f5e 0%, #f59e42 100%)"
                : "linear-gradient(90deg, #0ea5e9 0%, #38bdf8 100%)",
              boxShadow: "0 4px 16px 0 rgba(56,189,248,0.25)",
            },
          }}
        >
          {expanded ? "Read Less" : "Read More"}
        </Button>
      </Box>
      {/* Decorative Accent */}
      <Box
        sx={{
          position: "absolute",
          top: 12,
          right: 18,
          width: 18,
          height: 18,
          borderRadius: "50%",
          background: "linear-gradient(135deg, #f59e42 60%, #f43f5e 100%)",
          boxShadow: "0 2px 8px 0 rgba(244,63,94,0.15)",
        }}
      />
    </Box>
  );
}


export default BlogSection;
